import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '../../assets/img/logo-aportes-en-linea-retina.png'


const _hoisted_1 = { class: "header-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("td", { colspan: "4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "logo",
    class: "header_logo"
  })
], -1)
const _hoisted_3 = {
  key: 0,
  class: "summary"
}
const _hoisted_4 = { class: "text-green" }
const _hoisted_5 = { class: "text-gray" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "text-gray" }
const _hoisted_8 = { class: "text-green" }
const _hoisted_9 = { class: "question-pro-container" }
const _hoisted_10 = { id: "question-pro-tipo-identificacion" }
const _hoisted_11 = { id: "question-pro-identificacion" }
const _hoisted_12 = { id: "question-pro-usuario" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _hoisted_2,
          _createElementVNode("td", null, [
            ($setup.mostrarDatosEmpleador)
              ? (_openBlock(), _createElementBlock("table", _hoisted_3, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_4, _toDisplayString($setup.razonSocial), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_5, _toDisplayString($setup.tipoIdentificacion) + " " + _toDisplayString($setup.tipoIdentificacion == "NIT"
                      ? `${$setup.numeroIdentificacion}-${$setup.dv}`
                      : $setup.numeroIdentificacion), 1)
                    ]),
                    ($setup.sucursal)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                          _createElementVNode("td", _hoisted_7, [
                            _createTextVNode(" Sucursal: "),
                            _createElementVNode("span", _hoisted_8, _toDisplayString($setup.sucursal), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, _toDisplayString($setup.tipoIdentificacion), 1),
      _createElementVNode("div", _hoisted_11, _toDisplayString($setup.numeroIdentificacion), 1),
      _createElementVNode("div", _hoisted_12, _toDisplayString($setup.usuario), 1)
    ])
  ], 64))
}